import * as React from 'react';
import {
    Create,
    SimpleForm,
    SelectInput,
    required,
    TextInput,
    ArrayInput,
    SimpleFormIterator,
    FormDataConsumer,
    DateTimeInput,
} from 'react-admin';
import { SEGMENTATION_MODULE } from '../../common/constants';
import { validateNotEmpty } from '../../common/VideoPlayer/util';
import { TestSeriesAutocomplete } from '../../common/inputs/autoCompleteInputs/TestSeriesAutoCompleteInput';
import { ProgramAutocomplete } from '../../common/inputs/autoCompleteInputs/ProgramAutoComplete';
import { SubjectsAutoComplete } from '../../common/inputs/autoCompleteInputs/SubjectsAutoComplete';
import { BatchAutocomplete } from '../../common/inputs/autoCompleteInputs/BatchAutoComplete';

export const operatorChoices = [
    { id: 'AND', name: 'AND' },
    { id: 'OR', name: 'OR' },
];

export const ConditionTypeChoice = [
    { id: 'BATCH', name: 'Batch' },
    { id: 'PROGRAM', name: 'Programs' },
    { id: 'SUBJECT', name: 'Subjects' },
    { id: 'TESTSERIES', name: 'Test Series' },
    { id: 'USER', name: 'User' },
];

export const ConditionMethodsChoice = [{ id: '=', name: '= Equals' }];

const SegmentCreate = () => {
    return (
        <Create redirect="/segmentations">
            <SimpleForm defaultValues={{ condition: [{}] }}>
                <TextInput source="name" fullWidth validate={[required(), validateNotEmpty]} />

                <SelectInput
                    source="module"
                    label="Module"
                    fullWidth
                    validate={[required()]}
                    choices={SEGMENTATION_MODULE}
                />

                <ArrayInput source="condition">
                    <SimpleFormIterator>
                        <SelectInput
                            fullWidth
                            source="type"
                            label="Type"
                            choices={ConditionTypeChoice}
                            validate={[required()]}
                        />

                        <SelectInput
                            fullWidth
                            source="method"
                            label="Method"
                            choices={ConditionMethodsChoice}
                            validate={[required()]}
                        />

                        <FormDataConsumer>
                            {({ scopedFormData, getSource }) => {
                                const selectedType = ConditionTypeChoice.find(
                                    opt => opt.id === scopedFormData?.type,
                                )?.name;

                                if (!selectedType) return null;

                                switch (selectedType) {
                                    case 'Batch':
                                        return (
                                            <BatchAutocomplete
                                                source={getSource?.('value') ?? 'value'}
                                                validate={[required()]}
                                            />
                                        );
                                    case 'Programs':
                                        return (
                                            <ProgramAutocomplete
                                                source={getSource?.('value') ?? 'value'}
                                                validate={[required()]}
                                            />
                                        );
                                    case 'Subjects':
                                        return (
                                            <SubjectsAutoComplete
                                                source={getSource?.('value') ?? 'value'}
                                                validate={[required()]}
                                            />
                                        );
                                    case 'Test Series':
                                        return (
                                            <TestSeriesAutocomplete
                                                source={getSource?.('value') ?? 'value'}
                                                validate={[required()]}
                                            />
                                        );
                                    case 'User':
                                        return (
                                            <DateTimeInput
                                                source={getSource?.('value') ?? 'value'}
                                                fullWidth
                                                validate={[required()]}
                                            />
                                        );
                                    default:
                                        return null;
                                }
                            }}
                        </FormDataConsumer>

                        <SelectInput
                            source="operator"
                            fullWidth
                            label="Operator"
                            choices={operatorChoices}
                            validate={[required()]}
                        />
                    </SimpleFormIterator>
                </ArrayInput>
            </SimpleForm>
        </Create>
    );
};

export default SegmentCreate;
